import { render } from "./reportKitNameBill.vue?vue&type=template&id=fce96d94"
import script from "./reportKitNameBill.vue?vue&type=script&lang=js"
export * from "./reportKitNameBill.vue?vue&type=script&lang=js"

import "./reportKitNameBill.vue?vue&type=style&index=0&id=fce96d94&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__